


































































































import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class BotaoDeWhatsApp extends Vue {
	dialogo = false

	abrirWhatsApp() {
		// Número em formato internacional, somente dígitos (55 + DDD + número)
		const numero = '554735124168'
		const mensagem = 'Olá! Preciso de ajuda!'
		const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`
		window.open(url, '_blank')
		this.dialogo = false
	}
}
